import { render, staticRenderFns } from "./ConfirmSubmitSuspendProvider.vue?vue&type=template&id=1521552c&scoped=true&"
import script from "./ConfirmSubmitSuspendProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSubmitSuspendProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmSubmitSuspendProvider.vue?vue&type=style&index=0&id=1521552c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521552c",
  null
  
)

export default component.exports